import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import { CardExpansionPanel } from '~/modules/common/components';
import TaskEstimateTitle from './TaskEstimateTitle';
import TaskResourceEstimatesContent from './TaskResourceEstimatesContent';

export const useExpansionStyles = makeStyles(theme => ({
  expansionPanel: {
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    margin: '0 !important'
  },
  expansionPanelSummary: {
    alignItems: 'center',
    flexDirection: 'row-reverse',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.common.white
  },
  expansionPanelSummaryContent: {
    padding: 0
  },
  expandIcon: {
    padding: theme.spacing(1.5, 2, 1.5, 0.5)
  }
}));

export const TaskResourceEstimatesExpansionPanel = () => {
  const expansionClasses = useExpansionStyles();

  const titleComponentProps = useMemo(
    () => ({
      assignmentCount: 5,
      assignmentWithResourceCount: 5
    }),
    []
  );

  return (
    <CardExpansionPanel
      classes={expansionClasses}
      elevation={0}
      TitleComponent={TaskEstimateTitle}
      titleComponentProps={titleComponentProps}
      defaultExpanded={false}
    >
      <TaskResourceEstimatesContent />
    </CardExpansionPanel>
  );
};

TaskResourceEstimatesExpansionPanel.propTypes = {};

export default TaskResourceEstimatesExpansionPanel;
